export const Component = {
  fr: {
    SelectDefaultOption: "Veuillez sélectionner une option",
  },
  en: {
    SelectDefaultOption: "Please select an option",
  },
};
